(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df-mobile-buy"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('df-mobile-buy')){
  customElements.define('df-mobile-buy',class extends HTMLElement{
    connectedCallback(){
      this.section=document.querySelector('[data-section-type="product"][data-section-id="'+this.dataset.sectionId+'"]');
      if(!this.section)return;
      this.variants=JSON.parse(this.querySelector('[data-df-variants]').textContent);
      this.mobile=matchMedia('(max-width:749px)');
      this.update=()=>{
        const form=this.section.querySelector('[data-product-form]');
        const main=form?.querySelector('[data-add-to-cart]');
        if(!main)return;
        const variant=this.variants.find(item=>String(item.id)===form.querySelector('[name="id"]')?.value);
        const title=variant?.title==='Default Title'?this.section.querySelector('h1')?.textContent.trim():variant?.title||'';
        const price=main.querySelector('[data-button-price]')?.textContent.trim()||'';
        const label=main.querySelector('[data-add-to-cart-text]')?.textContent.trim()||main.getAttribute('aria-label');
        const nameEl=this.querySelector('[data-df-variant]');
        const priceEl=this.querySelector('[data-df-price]');
        const button=this.querySelector('[data-df-buy]');
        if(nameEl.textContent!==title)nameEl.textContent=title;
        if(priceEl.textContent!==price)priceEl.textContent=price;
        if(button.textContent!==label)button.textContent=label;
        const disabled=main.disabled||main.classList.contains('loading');
        if(button.disabled!==disabled)button.disabled=disabled;
        const cookie=document.querySelector('#shopify-pc__banner');
        const cookieOpen=cookie&&cookie.getBoundingClientRect().height>0;
        const drawerOpen=Boolean(document.querySelector('.drawer--visible'));
        const visible=this.mobile.matches&&main.getBoundingClientRect().bottom<0&&!cookieOpen&&!drawerOpen;
        if(this.hidden===visible)this.hidden=!visible;
        if(document.body.classList.contains('df-mobile-buy-visible')!==visible)document.body.classList.toggle('df-mobile-buy-visible',visible);
        const offset=document.querySelector('#PBarNextFrame')?'64px':'0px';
        if(this.style.getPropertyValue('--df-preview-offset')!==offset)this.style.setProperty('--df-preview-offset',offset);
      };
      this.queue=()=>{
        cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(this.update);
      };
      this.onChange=()=>{
        this.queue();clearTimeout(this.timer);this.timer=setTimeout(this.update,500);
      };
      this.onClick=()=>{
        const main=this.section.querySelector('[data-product-form] [data-add-to-cart]');
        if(main&&!main.disabled)main.click();
      };
      this.querySelector('[data-df-buy]').addEventListener('click',this.onClick);
      this.observer=new MutationObserver(this.queue);
      const wrapper=this.section.querySelector('[data-product-form-wrapper]');
      if(wrapper)this.observer.observe(wrapper,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','class','value','aria-checked']});
      this.drawerObserver=new MutationObserver(this.queue);
      document.querySelectorAll('.drawer').forEach(drawer=>this.drawerObserver.observe(drawer,{attributes:true,attributeFilter:['class']}));
      this.section.addEventListener('change',this.onChange);
      this.section.addEventListener('click',this.onChange);
      window.addEventListener('scroll',this.queue,{passive:true});
      window.addEventListener('resize',this.queue);
      this.update();
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.drawerObserver?.disconnect();
      cancelAnimationFrame(this.frame);clearTimeout(this.timer);
      this.section?.removeEventListener('change',this.onChange);
      this.section?.removeEventListener('click',this.onChange);
      window.removeEventListener('scroll',this.queue);window.removeEventListener('resize',this.queue);
      document.body.classList.remove('df-mobile-buy-visible');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["df-review-highlight"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('df-review-highlight')){
  customElements.define('df-review-highlight',class extends HTMLElement{
    connectedCallback(){
      let tries=0;
      const populate=()=>{
        const data=window.jdgm?.data?.reviewWidget?.[this.dataset.productId];
        const eligible=data?.reviews?.filter(item=>item.verified_buyer===true&&Number(item.rating)>=4&&item.body&&item.reviewer_name&&!item.is_anonymous_reviewer)||[];
        const review=this.dataset.reviewBody?eligible.find(item=>item.body.trim()===this.dataset.reviewBody):eligible[0];
        if(review){
          this.querySelector('[data-df-review-quote]').textContent=review.body;
          this.querySelector('[data-df-review-author]').textContent=review.reviewer_name;
          this.hidden=false;
          clearInterval(this.timer);
        }else if(++tries>=30)clearInterval(this.timer);
      };
      this.timer=setInterval(populate,1000);
      populate();
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["df-shopping-assist"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('df-shopping-assist')){
  customElements.define('df-shopping-assist',class extends HTMLElement{
    connectedCallback(){
      this.update=()=>{
        document.querySelectorAll('[data-section-type="product"]').forEach(section=>{
          const summary=section.querySelector('[data-df-choice]');
          if(summary){
            const selected=Array.from(section.querySelectorAll('.swatch-view [role="radio"][aria-checked="true"]')).map(item=>item.getAttribute('aria-label')).filter(Boolean).join(' / ');
            if(selected&&summary.textContent!==selected){
              summary.textContent=selected;
              const feedback=section.querySelector('[data-df-add-feedback]');
              if(feedback)feedback.hidden=true;
            }
          }
          const button=section.querySelector('[data-product-form] [data-add-to-cart]');
          const feedback=section.querySelector('[data-df-add-feedback]');
          if(button?.classList.contains('has-success')&&feedback){
            feedback.hidden=false;
            const complete=button.querySelector('.btn-state-complete');
            if(complete&&complete.textContent!==this.dataset.added)complete.textContent=this.dataset.added;
          }
        });
      };
      this.schedule=()=>{
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.frame=requestAnimationFrame(this.update);
        this.timer=setTimeout(this.update,400);
      };
      this.click=event=>{
        if(event.target.closest('.swatch-view,[data-add-to-cart],[data-df-buy]'))this.schedule();
      };
      this.submit=event=>{
        const button=event.target.querySelector('[data-add-to-cart]');
        if(!button)return;
        this.successObserver?.disconnect();
        this.successObserver=new MutationObserver(()=>{
          if(button.classList.contains('has-success')){
            this.update();this.successObserver.disconnect();
          }
        });
        this.successObserver.observe(button,{attributes:true,attributeFilter:['class']});
      };
      document.addEventListener('click',this.click);
      document.addEventListener('submit',this.submit,true);
      document.addEventListener('change',this.schedule);
      this.visibility=new IntersectionObserver(entries=>{
        entries.forEach(entry=>this.inView.set(entry.target,entry.isIntersecting));
        document.body.classList.toggle('df-purchase-in-view',Array.from(this.inView.values()).some(Boolean));
      });
      this.inView=new Map();
      document.querySelectorAll('[data-product-form-wrapper]').forEach(item=>this.visibility.observe(item));
      this.update();
    }
    disconnectedCallback(){
      this.successObserver?.disconnect();this.visibility?.disconnect();
      cancelAnimationFrame(this.frame);clearTimeout(this.timer);
      document.removeEventListener('click',this.click);
      document.removeEventListener('submit',this.submit,true);
      document.removeEventListener('change',this.schedule);
      document.body.classList.remove('df-purchase-in-view');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
